<template>
  <div class="elArchives">
    <!-- <input type="file" id="fujian"  accept=".pdf, .doc, .docx, .xls, .xlsx, .png , .jpg ,.jpeg" @change="handleChange"> -->
    电子档案
    <input
      type="file"
      accept=".pdf .png , .jpg , .doc"
      @change="handleChange"
    />
    <ul>
      <li v-for="item in list" :key="item.id">{{ item.resourceName }}</li>
    </ul>

    月度报告
    <input
      type="file"
      accept=".pdf .png , .jpg , .doc"
      @change="handleChange2"
    />
    <ul>
      <li v-for="item in MonthlyReportList" :key="item.id">
        {{ item.resourceName }}
      </li>
    </ul>
  </div>
</template>

<script>
import {
  saveRecord,
  findUnitRecord,
  findUnitMonthlyReport,
} from "../../api/abbNewApi";

export default {
  data() {
    return {
      list: [],
      MonthlyReportList: [],
    };
  },
  mounted() {
    this.findUnitRecord_fn();
    this.MonthlyReportList_fn();
  },
  methods: {
    //电子档案
    findUnitRecord_fn() {
      findUnitRecord().then((res) => {
        this.list = res.data;
      });
    },

    handleChange(ev) {
      const files = ev.target.files;
      const fileSuffix = files[0].name.substring(
        files[0].name.lastIndexOf(".") + 1
      );

      const whiteList = ["pdf", "doc", "docx", "png", "jpg", "jpeg"];
      //  const whiteList = ["pdf","png","jpg","doc"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message({message:"上传文件只能是 pdf、doc、docx、xls、xlsx、jpeg、png、jpg格式" ,type: 'error'});
        this.$message({
          message: "上传文件只能是 pdf、png、doc 、jpg格式",
          type: "error",
        });
        return false;
      }
      const data = new FormData();
      //使用append存储信息，append('键名','键值')
      data.append("file", files[0]);
      data.append("documentType", "electronic");

      saveRecord(data).then((res) => {
        if (res.code == 200) {
          this.$message({ message: "上传成功", type: "success" });
          this.findUnitRecord_fn();
        }
      });
    },
    handleChange2(ev) {
      const files = ev.target.files;

      const fileSuffix = files[0].name.substring(
        files[0].name.lastIndexOf(".") + 1
      );

      const whiteList = ["pdf", "doc", "docx", "png", "jpg", "jpeg"];
      //  const whiteList = ["pdf","png","jpg","doc"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message({message:"上传文件只能是 pdf、doc、docx、xls、xlsx、jpeg、png、jpg格式" ,type: 'error'});
        this.$message({
          message: "上传文件只能是 pdf、png、doc 、jpg格式",
          type: "error",
        });
        return false;
      }
      const data = new FormData();
      //使用append存储信息，append('键名','键值')
      data.append("file", files[0]);
      data.append("documentType", "report");
      saveRecord(data).then((res) => {
        if (res.code == 200) {
          this.$message({ message: "上传成功", type: "success" });
          this.MonthlyReportList_fn();
        }
      });
    },
    //月度报告
    MonthlyReportList_fn() {
      findUnitMonthlyReport().then((res) => {
        this.MonthlyReportList = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
